module.exports = __webpack_public_path__ + "img/symbol_2.90fb31d2.png";